var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendarSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7591 2.38672H6.11424C4.15644 2.38672 2.93359 3.47734 2.93359 5.48207V11.5152C2.93359 13.5514 4.15644 14.6673 6.11424 14.6673H11.7529C13.7169 14.6673 14.9336 13.5703 14.9336 11.5656V5.48207C14.9397 3.47734 13.7231 2.38672 11.7591 2.38672Z",
    stroke: "#1E2948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97217 11.4641H5.97834M11.895 8.87305H11.9011H11.895ZM8.93665 8.87305H8.94283H8.93665ZM5.97217 8.87305H5.97834H5.97217ZM11.895 11.4641H11.9011H11.895ZM8.93665 11.4641H8.94283H8.93665Z",
    stroke: "#1E2948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99561 6.26953H14.8782",
    stroke: "#1E2948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6294 1.33398V3.52784",
    stroke: "#1E2948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24414 1.33398V3.52784",
    stroke: "#1E2948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarSmall);
export default __webpack_public_path__ + "static/media/icon-calendar-small.cb4fba6140b0edd451f88315e927f55e.svg";
export { ForwardRef as ReactComponent };